import { useEffect } from "react";
import dynamic from "next/dynamic";
import config from "@/lib/config";
import { useBreadcrumbs } from "@/hooks";
import routes from "@/lib/routes";
import StorePageMetaTags from "@/components/MetaTags/StorePageMetaTags";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Canvas = dynamic(() => import("@/components/Canvas"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/Canvas")]
  }
});
export var __N_SSP = true;
export default function Store() {
  const {
    setBreadcrumbs
  } = useBreadcrumbs();
  const key = config.canvas.store.vod;
  useEffect(() => {
    setBreadcrumbs([{
      text: "ホーム",
      href: routes.home
    }, {
      text: "単品商品"
    }]);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StorePageMetaTags, {}), /*#__PURE__*/_jsx(Canvas, {
      idKey: key
    })]
  });
}